import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AwarePhishOverview from './AwarePhishOverview';
import AwarePhishCampaigns from './AwarePhishCampaigns';
import NewAwarePhishCampaign from './NewAwarePhishCampaign';
import AwarePhishCampaignDetail from './AwarePhishCampaignDetail';
import AwarePhishTemplates from './AwarePhishTemplates';
import AwarePhishSendingProfiles from './AwarePhishSendingProfiles';

export default function AwarePhishAdminSection({ companyId }) {
    return (
        <Routes>
            <Route
                path="/"
                element={<AwarePhishOverview companyId={companyId} />}
            />
            <Route
                path="campaigns"
                element={<AwarePhishCampaigns companyId={companyId} />}
            />
            <Route
                path="campaigns/new"
                element={<NewAwarePhishCampaign companyId={companyId} />}
            />
            <Route
                path="campaigns/:campaignId"
                element={<AwarePhishCampaignDetail companyId={companyId} />}
            />
            <Route
                path="templates"
                element={<AwarePhishTemplates companyId={companyId} />}
            />
            <Route
                path="sending-profiles"
                element={<AwarePhishSendingProfiles companyId={companyId} />}
            />
        </Routes>
    );
}
